import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import "./index.css";
import { IoCloseOutline } from 'react-icons/io5';
import { db } from '../../../../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { useAuth } from '../../../../context/AuthContext';

const SelectUnit = ({ propertyID, item, buttonTitle, buttonClass, buttonVariant, buttonSize, setUnitNumberPerFloor }) => {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [show, setShow] = useState(false);
  const [bookedUnits, setBookedUnits] = useState([]);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };

  async function getBookedUnits(propertyID) {
    const querySnapshot = await getDocs(collection(db, "Businesses", bid, "Properties", propertyID, "BookedUnits"));
    var tempDocs = [];
    querySnapshot.forEach((doc) => {
      tempDocs.push({ id: doc.id, ...doc.data() });
    });

    setBookedUnits(tempDocs);
  }

  useEffect(() => {
    if (propertyID) {
      getBookedUnits(propertyID);
    }
  }, [])

  return (
    <>
      <Button variant={buttonVariant} size={buttonSize} className={buttonClass} onClick={handleShow}>
        {buttonTitle ? buttonTitle : 'Button'}
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size='xl'
        dialogClassName="modal-wrapper"
        contentClassName="modal-custom-content overflow-hidden"
        centered
      >
        <div className='ps-1 border-bottom d-flex align-items-center justify-content-between'>
          <h5 className='mb-0 px-3'>Select Unit</h5>
          <Button
            variant='none'
            className='py-3 px-3 border-0'
            onClick={() => handleClose()}
          >
            <IoCloseOutline size={24} />
          </Button>
        </div>
        <div className='px-3 overflow-scroll'>
          {
            Array.from(Array(Number(item.numFloors)).keys()).map((floorItem, i) => {
              return (
                <div key={i} className='row my-2'>
                  <div className='col-md-2 mt-1'>
                    <div className='py-2 w-100 bg-light rounded text-center'>
                      Floor {floorItem + 1}
                    </div>
                  </div>
                  <div className='col-md-10'>
                    <div className='row'>
                      {
                        item.unitNumberPerFloor && item.unitNumberPerFloor.map((numFloorItem, j) => {
                          var isBooked = bookedUnits && bookedUnits.some((x) => (parseFloat(x.unitFloor) === parseFloat(floorItem + 1)) && (parseFloat(x.unitNumber) === parseFloat(numFloorItem.number)));

                          var unitNumberWithFloor = (floorItem + 1).toString();

                          if (numFloorItem.number && numFloorItem.number.length === 1) {
                            unitNumberWithFloor = `${unitNumberWithFloor}0${numFloorItem.number}`;
                          } else {
                            unitNumberWithFloor = `${unitNumberWithFloor}${numFloorItem.number}`;
                          }
                          return (
                            <div key={j} className={item.unitNumberPerFloor.length > 4 ? 'col-md-2 mt-1' : 'col mt-1'}>
                              <Button
                                size='sm'
                                disabled={isBooked && isBooked}
                                variant={isBooked && isBooked ? 'danger' : 'none'}
                                className={isBooked && isBooked ? 'w-100 py-2' : 'w-100 py-2 unit-btn'}
                                onClick={() => {
                                  setUnitNumberPerFloor(item, floorItem + 1, numFloorItem.number);
                                  handleClose();
                                }}
                              >
                                {unitNumberWithFloor}
                              </Button>
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </Modal>
    </>
  );
}

export default SelectUnit;
